(function () {
  'use strict';

  /**
   * True auf der eingeloggten Startseite (Dashboard). Nicht nur exakt
   * `/secure/user/index.html`: viele Server liefern `/secure/user/` oder `/secure/user`
   * ohne Suffix; optional mit Präfix (z. B. Staging unter Unterpfad).
   */
  function isMemberDashboardPath () {
    let path = window.location.pathname || ''
    while (path.length > 1 && path.endsWith('/')) {
      path = path.slice(0, -1)
    }
    if (path.endsWith('/index.html')) {
      path = path.slice(0, -'/index.html'.length)
      while (path.length > 1 && path.endsWith('/')) {
        path = path.slice(0, -1)
      }
    }
    return /(^|\/)secure\/user$/.test(path)
  }

  if (!isMemberDashboardPath()) {
    return
  }

  const user = JSON.parse(localStorage.getItem("user"))

  $(document).ready(function () {

    // Globale Information der Beratungsstelle laden (API 0.8.2 notice)
    loadBstNotice()
    // Geburtstagsgruß (API /authorized/me: birthday, birthdayLifePartner)
    loadBirthdayGreetings()
    // Hinweis wenn 2FA für das aktuelle Konto nicht aktiv ist
    loadMfaNotice()

    // DEBUG: ?debug=1 oder localStorage.debugMessages = true → alle Nachrichten ohne Gruppierung
    const isDebug = (typeof URLSearchParams !== 'undefined' && new URLSearchParams(window.location.search).get('debug') === '1') ||
      (typeof localStorage !== 'undefined' && localStorage.getItem('debugMessages') === 'true')
    const messageCount = isDebug ? 50 : 6

    // Auf Startseite alle Nachrichten anzeigen
    getAktMessagesUnreadOnly('', 'all', messageCount, 0, isDebug)
      .then(function(messages) {
        //console.log(JSON.stringify(messages, null, 2))
        if (isDebug && $('#messages .debug-hint').length === 0) {
          $('#messages h2').after('<p class="debug-hint text-warning small mb-2"><strong>DEBUG:</strong> Alle Nachrichten ohne Gruppierung (inkl. Antworten). Deaktivieren: <code>localStorage.removeItem(\'debugMessages\')</code> oder ohne <code>?debug=1</code></p>')
        }
        $('#messagesTableBody').html(messages || '')
      })
      .catch(function(err) {
        // Handle auth errors (401/403) if handleAuthError is available
        if (typeof handleAuthError === 'function' && handleAuthError(err, false)) {
          return // Will redirect to login
        }
        // Error loading messages - only log non-auth errors
        console.warn('Error loading messages on startpage:', err)
      })

  })

  /**
   * Prüft, ob ein ISO-Datum (YYYY-MM-DD) heute (lokal) Kalendertag und -monat hat.
   * @param {string|null|undefined} isoDate
   * @returns {boolean}
   */
  function isBirthdayAnniversaryToday (isoDate) {
    if (isoDate == null || typeof isoDate !== 'string') {
      return false
    }
    const m = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})/)
    if (!m) {
      return false
    }
    const month = parseInt(m[2], 10) - 1
    const day = parseInt(m[3], 10)
    const now = new Date()
    return now.getMonth() === month && now.getDate() === day
  }

  /** Heute als YYYY-MM-DD (lokal), für Test-Override. */
  function todayIsoLocal () {
    const n = new Date()
    return n.getFullYear() + '-' + ('0' + (n.getMonth() + 1)).slice(-2) + '-' + ('0' + n.getDate()).slice(-2)
  }

  /**
   * Testmodus Geburtstagsgruß: ?birthdayTest=1 bzw. ?birthdayTest=true auf der Startseite,
   * oder localStorage.setItem('debugBirthdayToday', 'true'). Deaktivieren: Parameter weglassen bzw.
   * localStorage.removeItem('debugBirthdayToday').
   */
  function isBirthdayGreetingTestMode () {
    try {
      if (typeof URLSearchParams !== 'undefined') {
        const p = new URLSearchParams(window.location.search)
        if (p.get('birthdayTest') === '1' || p.get('birthdayTest') === 'true') {
          return true
        }
      }
      if (typeof localStorage !== 'undefined' && localStorage.getItem('debugBirthdayToday') === 'true') {
        return true
      }
    } catch (e) { /* stillhalten */ }
    return false
  }

  /**
   * Geburtstagsgruß nur für das eingeloggte Mitglied (Geburtsdatum birthday, heute lokal).
   * Kein Hinweis für den Lebenspartner im Portal.
   */
  function loadBirthdayGreetings () {
    $.ajax({
      method: 'POST',
      url: '/cockpit/getmember',
      contentType: 'application/json; charset=UTF-8',
      data: JSON.stringify({}),
      processData: false,
      global: false
    }).then(function (result) {
      if (!result || !result.success || !result.data || !result.data.attributes) {
        return
      }
      const attrs = result.data.attributes

      if (isBirthdayGreetingTestMode()) {
        const td = todayIsoLocal()
        attrs.birthday = td
        console.info('[Geburtstagsgruß] Testmodus aktiv: birthday temporär auf', td, 'gesetzt.')
      }

      const memberDate = attrs.birthday != null && String(attrs.birthday).trim() !== '' ? attrs.birthday : null
      const memberToday = memberDate != null && String(memberDate).trim() !== '' && isBirthdayAnniversaryToday(String(memberDate))

      if (!memberToday) {
        $('#birthdayGreetingRow').hide()
        return
      }

      const fn = (attrs.firstName || '').trim()
      const ln = (attrs.lastName || '').trim()
      const name = escapeHtml((fn + ' ' + ln).trim() || 'Mitglied')
      const parts = ['<p>Herzlichen Glückwunsch zum Geburtstag, <strong>' + name + '</strong>!</p>']

      $('#birthdayGreeting').html(
        '<span class="birthday-greeting-icon fa fa-birthday-cake" aria-hidden="true"></span>' +
        '<div class="birthday-greeting-body">' + parts.join('') + '</div>'
      )
      $('#birthdayGreetingRow').show()
    }).catch(function (err) {
      if (typeof handleAuthError === 'function' && handleAuthError(err, false)) {
        return
      }
      console.warn('Geburtstagsgruß: Mitgliederdaten konnten nicht geladen werden.', err)
    })
  }

  /**
   * Hinweis auf der Startseite, wenn Zwei-Faktor-Authentifizierung nicht aktiv ist.
   * Link führt zum Tab „Login & Konten“ in den Stammdaten.
   */
  function loadMfaNotice () {
    $.ajax({
      method: 'GET',
      url: '/cockpit/my-identity',
      global: false
    }).then(function (result) {
      if (!result || !result.success || !result.data || !result.data.data) {
        return
      }
      const attrs = result.data.data.attributes || {}
      if (attrs.isTwoFactorEnabled === true) {
        $('#mfaNoticeRow').hide()
        return
      }

      const profileLink = 'profile.html#account-content'
      $('#mfaNotice').html(
        '<span class="mfa-notice-icon fa fa-shield" aria-hidden="true"></span>' +
        '<div class="mfa-notice-body">' +
        '<p><strong>Zwei-Faktor-Authentifizierung</strong></p>' +
        '<p>Schützen Sie Ihr Konto zusätzlich mit einem Bestätigungscode per E-Mail. ' +
        '<a href="' + profileLink + '">Jetzt unter „Login & Konten“ aktivieren</a>.</p>' +
        '</div>'
      )
      $('#mfaNoticeRow').show()
    }).catch(function (err) {
      if (typeof handleAuthError === 'function' && handleAuthError(err, false)) {
        return
      }
      console.warn('2FA-Hinweis: Identitätsdaten konnten nicht geladen werden.', err)
    })
  }

  /**
   * Lädt die globale Information (notice) der Beratungsstelle und zeigt sie an, wenn aktuell.
   * API 0.8.2: notice mit subject, message, startDate, endDate
   */
  function loadBstNotice() {
    $.ajax({
      method: 'POST',
      url: '/cockpit/getadvicecenter',
      global: false,
      data: {}
    }).then(function (result) {
      if (!result.success || !result.data) return

      let adviceCenter = null
      if (result.data.data) {
        adviceCenter = result.data.data
      } else if (result.data.attributes) {
        adviceCenter = result.data
      } else {
        adviceCenter = result.data
      }

      const attrs = adviceCenter.attributes || adviceCenter || {}
      const notice = attrs.notice

      if (!notice || typeof notice !== 'object' || !notice.subject || !notice.message) {
        return
      }

      const today = new Date()
      today.setHours(0, 0, 0, 0)

      const startDate = notice.startDate ? new Date(notice.startDate) : null
      const endDate = notice.endDate ? new Date(notice.endDate) : null

      if (startDate) startDate.setHours(0, 0, 0, 0)
      if (endDate) endDate.setHours(23, 59, 59, 999)

      const isActive = (!startDate || today >= startDate) && (!endDate || today <= endDate)
      if (!isActive) return

      const subject = escapeHtml(notice.subject)
      const message = notice.message // Kann HTML enthalten
      $('#bstNotice').html('<i class="fa fa-bullhorn bst-notice-icon"></i><div class="bst-notice-content"><strong>' + subject + '</strong><div class="mt-2">' + message + '</div></div>')
      $('#bstNoticeRow').show()
    }).catch(function () {
      // Stillhalten bei Fehler – notice ist optional
    })
  }
  
  // Funktion für alle Nachrichten (für Startseite)
  // debugMessages: wenn true, alle Nachrichten inkl. Antworten ohne Gruppierung (DEBUG)
  function getAktMessagesUnreadOnly(year, type, count, countstart, debugMessages) {
    const data = {
        messageyear: year,
        messagetype: type,
        messagecount: count,
        messagecountstart: countstart,
        onlyUnread: !debugMessages   // DEBUG: auch gelesene anzeigen
    }
    if (debugMessages) {
        data.debugMessages = true
    }
    // Kein enableArchiveActions: Archiv nur auf Vorgänge (filetransfer), nicht auf der Startseite
    return $.ajax({
        method: 'POST',
        url: '/cockpit/actmessages',
        contentType: 'application/json; charset=UTF-8',
        data: JSON.stringify(data),
        processData: false,
        global: false, // Prevent global error handler
    }).then(function (result) {
        // Gleiche Verarbeitung wie getAktMessages
        if (result && typeof result === 'object') {
            if (result.success === false) {
                return Promise.reject(new Error(result.error || 'Aktuelle Nachrichten können nicht abgerufen werden'))
            }
            if (result.success === true && result.data !== undefined) {
                return result.data
            }
        }
        if (result.error !== undefined) {
            return Promise.reject(new Error(result.error || 'Aktuelle Nachrichten können nicht abgerufen werden'))
        }
        return result
    }).catch(function (err) {
        // Pass through auth errors (401/403) with status intact
        if (err.status === 401 || err.status === 403) {
            return Promise.reject(err) // Keep original error with status
        }
        if (err.responseJSON && err.responseJSON.error) {
            return Promise.reject(new Error(err.responseJSON.error))
        }
        return Promise.reject(err)
    })
  }
})();

function displayMessageDetails(details) {
  const content = $('#messageDetailContent')
  
  // Validate that we have details
  if (!details) {
    content.html('<p class="text-muted">Keine Details verfügbar</p>')
    return
  }
  let html = '<div class="message-detail">'
  // Subject
  if (details.subject) {
    html += '<h5 class="mb-3">' + escapeHtml(details.subject) + '</h5>'
  }
  // Date
  if (details.date) {
    html += '<p class="text-muted mb-2"><small><i class="fa fa-calendar"></i> ' + escapeHtml(details.date) + '</small></p>'
  }
  // Type
  if (details.type) {
    html += '<p class="mb-2"><strong>Typ:</strong> ' + escapeHtml(details.type) + '</p>'
  }
  
  html += '</div>'
  
  content.html(html)

  const chatcontent = $('#messageConversationFirst')
  
  // Validate that we have details
  if (!details) {
    chatcontent.html('<p class="text-muted">Keine Details verfügbar</p>')
    return
  }
  let chathtml = '<div class="message-detail">'
  
  // Message/Content
  if (details.message) {
    chathtml += '<div class="d-flex mb-3"><div class="me-2"><span class="badge bg-brand-primary rounded-circle" style="width:32px;height:32px;display:inline-flex;align-items:center;justify-content:center;">HILO</span></div><div><div class="bg-light rounded p-2 mb-1">' + details.message + '</div><div class="text-muted" style="font-size:12px;">11:42</div></div></div>'
  } else if (details.content) {
    chathtml += '<div class="message-body border-top pt-3 mt-3">' + escapeHtml(details.content) + '</div>'
  }
  chathtml += '</div>'
  
  chatcontent.prepend(chathtml)
}

// Helper function to escape HTML to prevent XSS
function escapeHtml(text) {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  }
  return text.replace(/[&<>"']/g, function(m) { return map[m]; })
}

